export default __webpack_public_path__ + "static/media/17.1608f2cd.jpg";